module.exports = __webpack_public_path__ + "static/media/headerb.b7258ecb.jpg";